<template>
  <div class="scrollX">
    <ul class="investList-menu" flex>
      <router-link :to="{ name: 'RateToReturn' }">
        <li>
          {{ $t("RateToReturn.assetsStatus") }}
        </li>
      </router-link>
      <router-link :to="{ name: 'TransactionHistory' }">
        <li>
          {{ $t("RateToReturn.TransactionHistory") }}
        </li>
      </router-link>
      <router-link :to="{ name: 'RebaseList' }">
        <li>
          {{ $t("gnb.rebaseList.name") }}
        </li>
      </router-link>
      <router-link :to="{ name: 'RebaseORICList' }">
        <li>
          {{ $t("gnb.rebaseORICList.name") }}
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.scrollX {
  overflow-x: scroll;
  height: 48px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  .investList-menu {
    width: 454px;
    padding: 7px 12px;
    list-style: none;
    li {
      min-width: 88px;
      padding: 0 6px;
      margin-right: 8px;
      border: 1px solid #dcdfe3;
      border-radius: 52px;
      text-align: center;
      background-color: #fff;
      line-height: 32px;
      font-size: 12px;
      font-weight: normal;
      color: #333;
    }
    .router-link-active {
      li {
        border-color: #eb3246;
        background-color: #eb3246;
        color: #fff;
      }
    }
    a:last-child li {
      margin-right: 0;
    }
  }
}
</style>
